export const IconPushInArrow: {
  name: 'icon_push_in_arrow-726e6947d654'
} = {
  name: 'icon_push_in_arrow-726e6947d654'
}
